'use strict';

module.exports = function (OCL) {
    return function getConnectivityMatrix() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var sdt = options.sdt;
        var mass = options.mass;
        var atomicNo = options.atomicNo;

        this.ensureHelperArrays(OCL.Molecule.cHelperNeighbours);
        var nbAtoms = this.getAllAtoms();
        var result = new Array(nbAtoms);
        for (var i = 0; i < nbAtoms; i++) {
            result[i] = new Array(nbAtoms).fill(0);
            if (atomicNo) {
                result[i][i] = this.getAtomicNo(i);
            } else {
                result[i][i] = mass ? OCL.Molecule.cRoundedMass[this.getAtomicNo(i)] : 1;
            }
        }

        for (var _i = 0; _i < nbAtoms; _i++) {
            for (var j = 0; j < this.getAllConnAtoms(_i); j++) {
                result[_i][this.getConnAtom(_i, j)] = sdt ? this.getConnBondOrder(_i, j) : 1;
            }
        }
        return result;
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/openchemlib-extended/lib/extend/getConnectivityMatrix.js
// module id = 47
// module chunks = 0